import AdvertisedPayment from './AdvertisedPayment.vue'

export default AdvertisedPayment
